import React, { useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  NavLink,
  Switch,
  Route,
  useLocation,
  useHistory,
  useParams,
} from "react-router-dom";
import ClientList from "../components/NewsAndAnalysis/ClientList";
import Topics from "../components/Topics";
import Authorize from "../components/Authorize";
import { initFilters } from "../actions/filters-actions";
import { getCookie } from "../utility/cookieProvider";
import { COOKIE, CONSTANTS, TRACKING_ALLOWED_CLIENTS, LODR_CLIENTS } from "../constants/app-constant";
import { AddWidget, Dashboard } from "../components/Dashboard";
import { fetchClientDetails, isAuthenticated } from "../actions/client-action";
import {
  DashboardIcon,
  TagsIcon,
  ProfileIcon,
  AnalysisIcon,
  PrintOnlineIcon,
  SocialAccountsIcon,
  BlogForumsIcon,
  CloseIcon,
  LoginIcon,
  TvIcon,
  JounalistIcon,
  QualitativeIcon,
  TicketIcon,
  StockIcon,
  StockBlueIcon,
} from "../components/Icons/icons.component";
import ConceptLogo from "../assets/images/conceptbiu-logo.png";
import coalIndiaLogo from "../assets/images/wapcos.jpeg";
import NCCT_LOGO from "../assets/images/NCCT_LOGO.jpg";
import RELIANCE_LOGO from "../assets/images/RELIANCE_LOGO.png";
import JIO_LOGO from "../assets/images/jio.png";
import journolistLogo from "../assets/images/journolist-logo.png";
import journolistIcon from "../assets/images/journolist-icon.png";
import DashboardList from "../components/Dashboard/DashboardList";
import AnalysisMain from "../components/NewsAndAnalysis/Analysis/AnalysisMain";
import QualitativeMain from "../components/NewsAndAnalysis/NewAnalysis/AnalysisMain";
import Profile from "../components/Profile";
import TagsAndFavourites from "../components/NewsAndAnalysis/TagsAndFavourites";
import Notification from "../components/Notification";
import PrintAndOnlineNews from "../components/NewsAndAnalysis/News/PrintAndOnline";
import DashboardContainer from "../components/Dashboard/DashboardContainer";
import Tv from "../components/NewsAndAnalysis/News/TV";
import {
  FEED_DETAILS,
  FEED_DETAILS_ALL,
  NAVBAR_EXCLUDED_ROUTES,
} from "../constants/route-constants";
import Initials from "../components/Shared/Initials";
import { isLoggedIn, isOpenRoute } from "../utility/common-methods";
import TagFeeds from "../components/NewsAndAnalysis/TagsAndFavourites/Tags/TagFeeds";
// Temporary routes for designers below
import AddEntity from "../components/Dashboard/AddEntity";
import SocialNews from "../components/NewsAndAnalysis/News/Social";
import BlogsAndForum from "../components/NewsAndAnalysis/News/BlogAndForum";
import "../components/NewsAndAnalysis/client.sass";
import NewsDetailsMain from "../components/NewsAndAnalysis/News/NewsDetailsMain";
import DownloadReports from "../components/NewsAndAnalysis/DownloadReports";
import { ChangePassword } from "../components/Profile/UserProfile";
import moment from "moment";
import Tickets from "../components/Shared/Tickets";

const cilClientList = [
  "CIL",
  "Pralhad Joshi",
  "Central Coalfields Ltd",
  "Eastern Coalfields Ltd",
  "Western Coalfields Ltd",
  "Northern Coalfields Ltd",
  "South Eastern Coalfields Ltd",
  "Mahanadi Coalfields Ltd",
  "Central Mine Planning and Design Institute",
  "Singareni Collieries Company Ltd",
  "Bharat Coking Coal Ltd",
];

function Router() {
  const history = useHistory();
  const dispatch = useDispatch();
  const [selectedTab, setSelectedTab] = useState(CONSTANTS.TABS.PRINT);
  const [openAnalysis, setOpenAnalysis] = useState(false);
  const [pwdMsg, setpwdMsg] = useState(<div></div>);
  const [changePassword, setchangePassword] = useState(false);
  const [showWarn, setshowWarn] = useState(false);
  const clientState = useSelector((state) => state.clientReducer) || {};
  const { selectedClient, allowJournalistAccess, isAuth, passwordData } = clientState;
  const location = useLocation();
  const callApiClientDependentApis = !isOpenRoute(location.pathname);
  const { result } = isAuth;
  const qualitativeEnabled = useSelector(
    (state) => state.clientReducer.qualitativeSettings.qualitative
  );
  const userId = getCookie(COOKIE.CONCEPT_USER_ID);
  const userEmail = getCookie(COOKIE.CONCEPT_USER_EMAIL);
  const clientId = getCookie(COOKIE.CONCEPT_CLIENT_ID)
  useEffect(() => {
    if (isLoggedIn()) {
      dispatch(fetchClientDetails(callApiClientDependentApis));
    } else if (!isLoggedIn) {
      dispatch(isAuthenticated());
    }
  }, []);

  useEffect(() => {
    if(isLoggedIn() && Object.keys(passwordData).length && !passwordData.hasOwnProperty('status')){
      if(moment().diff(moment(passwordData.data.last_updated_at),'days') >= 90){
        setchangePassword(true)
        // setpwdMsg("Last password change has done before 90 days. Kindly change the password.")
      }
      // else if(passwordData.data.updated_by_admin === "1"){
      //   setchangePassword(true)
      //   // setpwdMsg("Operation team has reset the password. Kindly change the password.")
      // }
      else if(moment().diff(moment(passwordData.data.last_updated_at),'days') >= 80){
        setshowWarn(true)
        setpwdMsg(<div style={{fontSize:"small"}}>Your password is about to expire on {moment(passwordData.data.last_updated_at).add(90,"days").format("DD")+"th"+moment(passwordData.data.last_updated_at).add(90,"days").format(" MMM YYYY")}. Kindly change it</div>)
        // setpwdMsg("Last password change has done before 90 days. Kindly change the password.")
      }
    }
  },[passwordData])

  useEffect(() => {
    const menuBtn = document.getElementById("menuBtn");
    const menuCloseBtn = document.getElementById("menuCloseBtn");
    if (menuBtn) {
      menuBtn.addEventListener("click", () =>
        document.body.classList.add("leftNavigationOpen")
      );
    }
    if (menuCloseBtn) {
      menuCloseBtn.addEventListener("click", () =>
        document.body.classList.remove("leftNavigationOpen")
      );
    }
  });

  const id = selectedClient && selectedClient.id;
  useEffect(() => {
    if (id && callApiClientDependentApis) {
      dispatch(initFilters({ clientId: id }));
    }
  }, [id]);

  const access_token = getCookie(COOKIE.AUTH_TOKEN);

  const renderNavbar = () => {
    if (location.pathname) {
      return NAVBAR_EXCLUDED_ROUTES.includes(location.pathname);
    } else if (!isLoggedIn() && location.pathname) {
      renderNavbarForNewsDetainsPage();
    }
  };

  const renderNavbarForNewsDetainsPage = () => {
    const locationSubString = location.pathname;
    return FEED_DETAILS_ALL.includes(locationSubString.slice(0, 7));
  };

  const handleJournalistClick = () => {
    if (allowJournalistAccess && access_token) {
      window.open(
        `http://journolist.conceptbiu.com/Journopressrelease?token=${access_token}`
      );
      return;
    }
    history.push("/access-denied");
  };

  return (
    <>
      {!renderNavbar() &&
      isLoggedIn() && (
        <>
          <div className="leftNavigationWrap">
            <div className="leftNavigationTop">
              {selectedClient &&
              (selectedClient && (selectedClient.id === "9709" || selectedClient.id === "11626" )) === true ? (
                <div className="logoWraps">
                  { selectedClient.id === "9709" ? <img
                    src={NCCT_LOGO}
                    alt="Coal India"
                    className="userImages"
                    width="65"
                    onClick={() => history.push("/")}
                    // style={{ flex: "auto" }}
                  /> : <img
                  src={RELIANCE_LOGO}
                  alt="Reliance Group"
                  className="userImages"
                  width="200"
                  height="40"
                  onClick={() => history.push("/")}
                  // style={{ flex: "auto" }}
                />}
                  <span className="menuCloseBtn" id="menuCloseBtn">
                    <CloseIcon />
                  </span>
                </div>
              ) : (selectedClient && selectedClient.id == "11734"?(
                <div className="logoWrap">
                  <img
                    src={JIO_LOGO}
                    alt="Client Logo"
                    className="userImage"
                    width="65"
                    height="65"
                    onClick={() => history.push("/")}
                  />
                  <span className="menuCloseBtn" id="menuCloseBtn">
                    <CloseIcon />
                  </span>
                </div>
              ):cilClientList.indexOf(selectedClient.client_name) < 0 ? (
                <div className="logoWrap">
                  <img
                    src={ConceptLogo}
                    alt="Concept BIU"
                    className="userImage"
                    width="65"
                    height="65"
                    onClick={() => history.push("/")}
                  />
                  <span className="menuCloseBtn" id="menuCloseBtn">
                    <CloseIcon />
                  </span>
                </div>
              ) : (
                <div className="logoWraps">
                  <img
                    src={coalIndiaLogo}
                    alt="Coal India"
                    className="userImages"
                    width="65"
                    onClick={() => history.push("/")}
                    // style={{ flex: "auto" }}
                  />
                  <span className="menuCloseBtn" id="menuCloseBtn">
                    <CloseIcon />
                  </span>
                </div>
              ))}

              <div className="userDropdownWrap d-flex">
                {/* {selectedClient &&
                selectedClient.client_logo &&
                selectedClient.hide_client_logo == "0" ? (
                  <div className="userImageWrap">
                    <img
                      src={selectedClient.client_logo}
                      alt={selectedClient.client_name}
                      className="userImage"
                    />
                  </div>
                ) : ( */}
                <span className="orgImageWrap">
                  {selectedClient.client_name ? (
                    <Initials name={selectedClient.client_name} />
                  ) : null}
                </span>
                {/* )} */}
                {isLoggedIn() ? <ClientList /> : null}
              </div>
            </div>
            {isLoggedIn() && (
              <>
                <ul className="leftNavigationMenu">
                  <li>
                    <NavLink
                      onClick={(e) => setOpenAnalysis(false)}
                      to={`/dashboard`}
                      activeClassName="active"
                    >
                      <span className="menuIcon">
                        <DashboardIcon />
                      </span>
                      <span className="menuTitle">Dashboards</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={(e) => setOpenAnalysis(false)}
                      to={`/feedlist`}
                      activeClassName="active"
                    >
                      <span className="menuIcon">
                        <PrintOnlineIcon />
                      </span>
                      <span className="menuTitle">Print & Online</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      onClick={(e) => setOpenAnalysis(false)}
                      to={`/social`}
                      activeClassName="active"
                    >
                      <span className="menuIcon">
                        <SocialAccountsIcon />
                      </span>
                      <span className="menuTitle">Social</span>
                    </NavLink>
                  </li>
                  {/* Commanded due to sanjay ji request */}
                  {/* <li>
                    <NavLink
                      onClick={(e) => setOpenAnalysis(false)}
                      to={`/blog-and-forums`}
                      activeClassName="active"
                    >
                      <span className="menuIcon">
                        <BlogForumsIcon />
                      </span>
                      <span className="menuTitle">Blogs & Forums</span>
                    </NavLink>
                  </li> */}
                  <li>
                    {/* for demo */}
                    <NavLink
                      onClick={(e) => setOpenAnalysis(false)}
                      to={"/tv"}
                      activeClassName="active"
                    >
                      <span className="menuIcon">
                        <TvIcon />
                      </span>
                      <span className="menuTitle">TV</span>
                    </NavLink>
                  </li>
                  {!qualitativeEnabled && (
                    <li>
                      <NavLink
                        onClick={(e) => setOpenAnalysis(false)}
                        to={`/analysis`}
                        activeClassName="active"
                      >
                        <span className="menuIcon">
                          <AnalysisIcon />
                        </span>
                        <span className="menuTitle">Analysis</span>
                      </NavLink>
                    </li>
                  )}
                  {qualitativeEnabled && (
                    <li>
                      <NavLink
                        to={"#"}
                        onClick={(e) =>
                          setOpenAnalysis(openAnalysis === true ? false : true)
                        }
                        activeClassName="active"
                        isActive={(match, location) => {
                          if (!match) {
                            return false;
                          }
                          if (
                            match.url === "/analysis" ||
                            match.url === "/qualitativeanalysis"
                          ) {
                            return true;
                          }
                        }}
                      >
                        <span className="menuIcon">
                          <AnalysisIcon />
                        </span>
                        <span className="menuTitle"> Analysis</span>
                      </NavLink>
                      {openAnalysis === true && (
                        <ul style={{ marginLeft: "-34px" }}>
                          <li style={{ padding: "1px 22px", fontSize: "14px" }}>
                            <NavLink
                              onClick={(e) => setOpenAnalysis(false)}
                              to={`/analysis`}
                              activeClassName="active"
                            >
                              <span className="menuIcon">
                                <AnalysisIcon />
                              </span>
                              <span className="menuTitle">Quantitative</span>
                            </NavLink>
                          </li>
                          {qualitativeEnabled && (
                            <li
                              style={{
                                padding: "1px 22px",
                                fontSize: "14px",
                              }}
                            >
                              <NavLink
                                onClick={(e) => setOpenAnalysis(false)}
                                to={`/qualitativeanalysis`}
                                activeClassName="active"
                              >
                                <span className="menuIcon">
                                  <QualitativeIcon />
                                </span>
                                <span className="menuTitle">Qualitative </span>
                              </NavLink>
                            </li>
                          )}
                        </ul>
                      )}
                    </li>
                  )}

                  {/* <li>
                    <NavLink to={`/downloadreport`} activeClassName="active">
                      <span className="menuIcon">
                        <AnalysisIcon />
                      </span>
                      <span className="menuTitle">Download Report</span>
                    </NavLink>
                  </li> */}
                  {selectedClient?.is_stock_display == "1"?
                    <li>
                      <a href="/v2/stock-value">
                        <span className="menuIcon">
                          <StockBlueIcon />
                        </span>
                        <span className="menuTitle">MPM</span>
                      </a>
                    </li>
                  :""}
                  <li>
                    <NavLink
                      onClick={(e) => setOpenAnalysis(false)}
                      to={`/tags_favourites/tags`}
                      activeClassName="active"
                    >
                      <span className="menuIcon">
                        <TagsIcon />
                      </span>
                      <span className="menuTitle">Tags & Favorites</span>
                    </NavLink>
                  </li>
                  {/* <li>
                    <NavLink to={`/notification`} activeClassName="active">
                      <span className="menuIcon">
                        <NotificationsMenuIcon />
                      </span>
                      <span className="menuTitle">Notifications</span>
                    </NavLink>
                  </li> */}
                  {TRACKING_ALLOWED_CLIENTS.includes(clientId)?
                    <li>
                      <NavLink
                        onClick={(e) => setOpenAnalysis(false)}
                        to={`/article-tracking`}
                        activeClassName="active"
                      >
                        <span className="menuIcon">
                          <TicketIcon />
                        </span>
                        <span className="menuTitle">Article Tracking</span>
                      </NavLink>
                    </li>
                  :""}
                  <li>
                    <NavLink
                      onClick={(e) => setOpenAnalysis(false)}
                      to={`/profile`}
                      activeClassName="active"
                    >
                      <span className="menuIcon">
                        <ProfileIcon />
                      </span>
                      <span className="menuTitle">Profile</span>
                    </NavLink>
                  </li>
                  {/* //Commanded due to sanjay ji request */}
                  {/* {selectedClient &&
                    cilClientList.indexOf(selectedClient.client_name) < 0 && (
                      <li onClick={() => handleJournalistClick()}>
                        <NavLink
                          onClick={(e) => setOpenAnalysis(false)}
                          to={"#"}
                          isActive={(match, location) => {
                            if (!match) {
                              return false;
                            }
                          }}
                        >
                          <span className="menuIcon">
                            <JounalistIcon />
                          </span>
                          <span className="menuTitle">JournoLIST</span>
                        </NavLink>
                      </li>
                    )} */}
                  {/* <li>
                    <NavLink
                      to={`/topics/1`}
                      isActive={() => window.location.pathname.indexOf("topics") > -1}
                      activeClassName="active"
                    >
                      <span className="menuIcon">
                        <TopicsIcon />
                      </span>
                      <span className="menuTitle">Topics</span>
                    </NavLink>
                  </li> */}
                </ul>
              </>
            )}{" "}
            {!isLoggedIn() && (
              <>
                <ul className="leftNavigationMenu">
                  <li>
                    (
                    <NavLink to={`/`} activeClassName="">
                      <span className="menuIcon">
                        <LoginIcon />
                      </span>
                      <span className="menuTitle">Login</span>
                    </NavLink>
                    )
                  </li>
                </ul>
              </>
            )}
          </div>
          <div className="appContainer">
            <Switch>
              <Route
                name="addEntity"
                path={`/add-entity`}
                render={(props) => <AddEntity {...props} />}
                exact
              />
              <Route
                name="changePassword"
                path={`/change-password`}
                render={(props) => <ChangePassword {...props} />}
                exact
              />
              <Route
                name="dashboardContainer"
                path={`/dashboard`}
                render={(props) => <DashboardContainer {...props} />}
                exact
              />
              <Route
                name="dashboard"
                path={`/dashboard/list`}
                render={(props) => <DashboardList {...props} />}
                exact
              />
              <Route
                name="dashboardDetails"
                path={`/dashboard/:dashboard_id`}
                exact
                render={(props) => (
                  <Dashboard key={props.match.params.dashboard_id} {...props} />
                )}
              />
              <Route
                name="widget"
                path={`/dashboard/:dashboard_id/widget`}
                render={(props) => <AddWidget {...props} />}
              />
              <Route
                name="topics"
                exact
                path={`/topics/:topicTabId`}
                render={(props) => (
                  <Topics
                    selectedTab={selectedTab}
                    setSelectedTab={setSelectedTab}
                    {...props}
                  />
                )}
              />
              <Route
                name="social-feed-list"
                exact
                path={`/social`}
                render={(props) => (
                  <SocialNews setSelectedTab={setSelectedTab} {...props} />
                )}
              />
              <Route
                name="blogs-and-forums-feed-list"
                exact
                path={`/blog-and-forums`}
                render={(props) => (
                  <BlogsAndForum setSelectedTab={setSelectedTab} {...props} />
                )}
              />
              <Route
                name="tv"
                exact
                path={`/tv`}
                render={(props) => <Tv {...props} />}
              />
              <Route
                name="authorize"
                exact
                path={`/authorize`}
                render={(props) => <Authorize {...props} />}
              />
              <Route
                name="main-analysis-page"
                exact
                path={`/analysis`}
                render={(props) => <AnalysisMain {...props} />}
              />
              <Route
                name="main-qualitative-page"
                exact
                path={`/qualitativeanalysis`}
                render={(props) => <QualitativeMain {...props} />}
              />
              <Route
                name="feed-list"
                exact
                path={`/feedlist`}
                render={(props) => <PrintAndOnlineNews {...props} />}
              />
              <Route
                name="profile"
                exact
                path={`/profile`}
                render={(props) => <Profile {...props} />}
              />
              <Route
                name="tags-and-favourites"
                exact
                path={`/tags_favourites/:tabName`}
                render={(props) => <TagsAndFavourites />}
              />
              <Route
                name="tagFeeds"
                exact
                path={`/tags_favourites/:tagsOrFavourite/:tagId/:verticalId`}
                render={(props) => <TagFeeds {...props} />}
              />
              <Route
                name="notification"
                exact
                path={`/notification`}
                render={(props) => <Notification {...props} />}
              />
              <Route
                name="article-tracking"
                exact
                path={`/article-tracking`}
                render={(props) => <Tickets {...props} />}
              />
              <Route
                name="youtube"
                exact
                path={`/youtube`}
                render={(props) => (
                  <>
                    <h2>Welcome to youtube feeds.</h2>
                  </>
                )}
              />
            </Switch>
          </div>
          {/* {changePassword || showWarn?
            
          :""} */}
        </>
      )}
      {useMemo(() => (<ChangePassword
        key={Math.random()}
        selectedClient={selectedClient}
        msg={pwdMsg}
        userId={userId}
        userEmail={userEmail}
        show={changePassword}
        showWarn={showWarn}
        closeBtn={showWarn?true:false}
        handleClose={() => setchangePassword(false)}
        handleWarnClose={() => setshowWarn(false)}
      />),[selectedClient,pwdMsg,userId,userEmail,changePassword,showWarn])}
    </>
  );
}

export default Router;
